import React from 'react';
import { Hero } from '../components/sections/Hero';
import { ProblemSolution } from '../components/sections/ProblemSolution';
import { Curriculum } from '../components/sections/Curriculum';
import { Deliverables } from '../components/sections/Deliverables';
import { Testimonials } from '../components/sections/Testimonials';
import { Safety } from '../components/sections/Safety';
import { PricingFAQ } from '../components/sections/PricingFAQ';
import { StickyBar } from '../components/StickyBar';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-320">
      <Hero data-id="element-321" />
      <ProblemSolution data-id="element-322" />
      <Curriculum data-id="element-323" />
      <Deliverables data-id="element-324" />
      <Testimonials data-id="element-325" />
      <Safety data-id="element-326" />
      <PricingFAQ data-id="element-327" />
      <Footer data-id="element-328" />
      <StickyBar data-id="element-329" />
    </div>;
}